import { render, staticRenderFns } from "./Sifarnik.vue?vue&type=template&id=3d87e8c6"
import script from "./Sifarnik.vue?vue&type=script&lang=js"
export * from "./Sifarnik.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports